import React, { useState } from "react";
import EntryColor from "../container/EntryColor";
import ModalOpenBetsChart from "../modals/ModalOpenBetsChart";
import SwitchActiveBetsColum from "../utilities/SwitchActiveBetsColum";
import ButtonOpenBetsBetType from "../utilities/ButtonOpenBetsBetType";

const Picks = ({
  charts,
  getOpenBetsChartModal,
  openBetsChartInfo,
  setOpenBetsChartInfo,
  userInfo,
  idPick,
  pickNumber,
  raceNumber,
  raceID,
  voidTickets,
  callTicketVoidListFrom,
  selectedTicketsVoidScore,
  setSelectedTicketsVoidScore,
  selectAllTickets,
  setSelectAllTickets,
  scoreTickets,
  setCallTicketVoidListFrom,
  setSelectionsSelected,
  getCharts,
}) => {
  const [showBetsColumnPicks, setShowBetsColumnPicks] = useState(false);

  var tableContent = [],
    headers = [],
    headersP;

  for (let index = 0; index < pickNumber; index++) {
    const element = <th key={index}>R{raceNumber++}</th>;
    headers.push(element);
  }

  if (charts) {
    tableContent = charts.map((chart, i) => {
      let selections = chart.Selections.split(",");
      return (
        <tr key={i}>
          <td>
            <EntryColor
              entryNum={parseInt(selections[0])}
              saddleNum={selections[0]}
            />
          </td>
          <td>
            <EntryColor
              entryNum={parseInt(selections[1])}
              saddleNum={selections[1]}
            />
          </td>
          <td>
            <EntryColor
              entryNum={parseInt(selections[2])}
              saddleNum={selections[2]}
            />
          </td>
          {pickNumber === 4 && (
            <td>
              <EntryColor
                entryNum={parseInt(selections[3])}
                saddleNum={selections[3]}
              />
            </td>
          )}
          {pickNumber === 5 && (
            <>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[3])}
                  saddleNum={selections[3]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[4])}
                  saddleNum={selections[4]}
                />
              </td>
            </>
          )}
          {pickNumber === 6 && (
            <>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[3])}
                  saddleNum={selections[3]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[4])}
                  saddleNum={selections[4]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[5])}
                  saddleNum={selections[5]}
                />
              </td>
            </>
          )}
          {pickNumber === 7 && (
            <>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[3])}
                  saddleNum={selections[3]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[4])}
                  saddleNum={selections[4]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[5])}
                  saddleNum={selections[5]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[6])}
                  saddleNum={selections[6]}
                />
              </td>
            </>
          )}
          {pickNumber === 8 && (
            <>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[3])}
                  saddleNum={selections[3]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[4])}
                  saddleNum={selections[4]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[5])}
                  saddleNum={selections[5]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[6])}
                  saddleNum={selections[6]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[7])}
                  saddleNum={selections[7]}
                />
              </td>
            </>
          )}
          {pickNumber === 9 && (
            <>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[3])}
                  saddleNum={selections[3]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[4])}
                  saddleNum={selections[4]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[5])}
                  saddleNum={selections[5]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[6])}
                  saddleNum={selections[6]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[7])}
                  saddleNum={selections[7]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[8])}
                  saddleNum={selections[8]}
                />
              </td>
            </>
          )}
          {pickNumber === 10 && (
            <>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[3])}
                  saddleNum={selections[3]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[4])}
                  saddleNum={selections[4]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[5])}
                  saddleNum={selections[5]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[6])}
                  saddleNum={selections[6]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[7])}
                  saddleNum={selections[7]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[8])}
                  saddleNum={selections[8]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[9])}
                  saddleNum={selections[9]}
                />
              </td>
            </>
          )}
          {pickNumber === 11 && (
            <>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[3])}
                  saddleNum={selections[3]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[4])}
                  saddleNum={selections[4]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[5])}
                  saddleNum={selections[5]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[6])}
                  saddleNum={selections[6]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[7])}
                  saddleNum={selections[7]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[8])}
                  saddleNum={selections[8]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[9])}
                  saddleNum={selections[9]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[10])}
                  saddleNum={selections[10]}
                />
              </td>
            </>
          )}
          {pickNumber === 12 && (
            <>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[3])}
                  saddleNum={selections[3]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[4])}
                  saddleNum={selections[4]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[5])}
                  saddleNum={selections[5]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[6])}
                  saddleNum={selections[6]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[7])}
                  saddleNum={selections[7]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[8])}
                  saddleNum={selections[8]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[9])}
                  saddleNum={selections[9]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[10])}
                  saddleNum={selections[10]}
                />
              </td>
              <td>
                <EntryColor
                  entryNum={parseInt(selections[11])}
                  saddleNum={selections[11]}
                />
              </td>
            </>
          )}
          <td style={{ fontWeight: "bold", verticalAlign: "middle" }}>
            ${chart.Amount.toFixed(2)}
          </td>
          {showBetsColumnPicks && (
            <td
              style={{ verticalAlign: "middle" }}
              className="cantBets"
              data-toggle="modal"
              data-target="#openBetsChartModal"
              onClick={() => {
                getOpenBetsChartModal(idPick, chart.Selections);
                setSelectionsSelected(chart.Selections);
              }}
            >
              {chart.BetCount}
            </td>
          )}
        </tr>
      );
    });
  }

  headersP = (
    <tr className="text-center">
      {headers}
      <th>Money</th>
      {showBetsColumnPicks && <th># Bets</th>}
    </tr>
  );

  return (
    <>
      <ModalOpenBetsChart
        openBetsChartInfo={openBetsChartInfo}
        setOpenBetsChartInfo={setOpenBetsChartInfo}
        userInfo={userInfo}
        wagerTypeId={idPick}
        voidTickets={voidTickets}
        callTicketVoidListFrom={callTicketVoidListFrom}
        selectedTicketsVoidScore={selectedTicketsVoidScore}
        setSelectedTicketsVoidScore={setSelectedTicketsVoidScore}
        selectAllTickets={selectAllTickets}
        setSelectAllTickets={setSelectAllTickets}
        scoreTickets={scoreTickets}
        setCallTicketVoidListFrom={setCallTicketVoidListFrom}
        getCharts={getCharts}
      />
      <div className="row">
        <div className="col-sm-6">
          <SwitchActiveBetsColum
            showBetsColumn={showBetsColumnPicks}
            setShowBetsColumn={setShowBetsColumnPicks}
          />
        </div>
        <div className="col-sm-6" style={{ textAlign: "right" }}>
          <ButtonOpenBetsBetType
            ticketType={idPick}
            raceID={raceID}
            userInfo={userInfo}
            openBetsChartInfo={openBetsChartInfo}
            setOpenBetsChartInfo={setOpenBetsChartInfo}
          />
        </div>
      </div>

      <table className="table table-striped table-sm mt-2">
        <thead>{headersP}</thead>
        <tbody className="table-sm text-center table-bordered">
          {tableContent}
        </tbody>
      </table>
    </>
  );
};

export default Picks;
